import $ from 'jquery';
import _ from 'underscore';
import { getGridName } from '@bingads-webui-campaign/inline-download-grids-metadata';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { validateOrder, handleShowRejectionReasonEnter, handleShowRejectionReasonLeave } from '@bingads-webui-campaign/summary-grid-helper';
import { getColumnsConfig } from './columns/index';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/responsive-search-ad');
const stateManager = globalContext.require('StateManager/CampaignStateManager');
const preferenceService = globalContext.requireDefault('component/preference/service/index');
const config = globalContext.require('component/config/index');
const pageContext = globalContext.require('PageContext');

export function getConfig({
  dataSource,
  scope,
  view,
  filterService,
  preferenceConfig,
  router,
  isForVNext,
  viewport,
  customHeaderOffset,
  serverContext,
}) {
  const tableName = i18n.getString('RSA_Assets');
  const permissions = pageContext.Permissions;
  const { campaignType } = scope.values;

  const events = {
    'click .delivery_status_with_reject_reasons': _.debounce(view.showRejectionReason.bind(view), 50),
    'mouseenter .delivery_status_with_reject_reasons': _.partial(handleShowRejectionReasonEnter, view, view.showRejectionReason),
    'mouseleave .delivery_status_with_reject_reasons': _.partial(handleShowRejectionReasonLeave, null, _.noop),
    'mouseleave .grid-column-Delivery': _.debounce(view.hideRejectionPopup.bind(view), 50),
  };

  const gridConfig = {
    name: getGridName('Assets'),
    legacyGridName: 'AssetsGrid',
    tableClasses: ['table', 'table-bordered'],
    tableAttributes: { 'aria-label': tableName },
    dataSource,
    selection: false,
    filterService,
    rows: {
      headRows: ['column-header-rows'],
    },
    columns: getColumnsConfig({
      i18n,
      scope,
      view,
      router,
      isForVNext,
      ShowVideoMetrics: permissions.dynamic && permissions.dynamic.AudienceAssetReport && campaignType === 'Audience',
      SearchAssetConversionColumn: permissions.dynamic && permissions.dynamic.SearchAssetConversionColumn,
      AssetBasedEditorialForRSA: permissions.dynamic && permissions.dynamic.AssetBasedEditorialForRSA,
      AssetBasedEditorialForAIM: permissions.dynamic && permissions.dynamic.AssetBasedEditorialForAIM,
      serverContext,
      permissions,
    }),
    scrolling: {
      header: {
        type: 'sticky',
        offset: customHeaderOffset || (() => $('nav.navbar-default.navbar-fixed-top').height()),
        attributes: { 'aria-label': i18n.getString('{{tableName}} table header', { tableName }) },
      },
      virtualized: true,
    },
    stateManager,
    preferenceService,
    config,
    events,
  };

  validateOrder(preferenceConfig, gridConfig.columns);

  if (viewport) {
    gridConfig.scrolling.viewport = viewport;
  }

  return gridConfig;
}
